const _ = "styles-module__container___1-rfC", e = "styles-module__content___GLH4j", t = "styles-module__price___HetxS", o = "styles-module__validity_period___7wbYM", n = "styles-module__description___DmqM7", s = "styles-module__send_details_container___Dmlrn", i = "styles-module__send_gift_card_title___Qutwc", d = "styles-module__gift_to_someone_form___-R2MD", c = {
  container: _,
  content: e,
  "image-container": "styles-module__image-container___unwG9",
  price: t,
  validity_period: o,
  description: n,
  send_details_container: s,
  send_gift_card_title: i,
  gift_to_someone_form: d
};
export {
  _ as container,
  e as content,
  c as default,
  n as description,
  d as gift_to_someone_form,
  t as price,
  s as send_details_container,
  i as send_gift_card_title,
  o as validity_period
};
